module.exports = __webpack_public_path__ + "static/img/55.804b0da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/55.png
// module id = SbIo
// module chunks = 0